import { Activity, FileText, House, Link2, Settings } from 'lucide-react';
import type { AppNavItem } from '@okrapdf/ui';

// Workspace nav for the icon rail (W.4.105): Home — the Studio's create-first
// home — leads, the resource pages follow, and Settings sits below a divider.
// The rail keeps app navigation to one narrow column so the page gets the
// width; self-host and solo render the same @okrapdf/ui AppShell as a drawer.
// Files / Collections / Tables / Workflows are hidden until ready — their
// routes redirect to /documents (see app.tsx). Agents is hidden the same way
// (its /agents routes stay live for direct URLs). Re-add entries to re-enable.
//
// One list for the signed-in shell and for the public landing (W.4.107), which
// shows the same rail to a visitor.
//
// Links (W.4.124 R4) replaced Analytics: the views belong to links, and the
// tab's own action is Create link.
export const WORKSPACE_HOME_KEY = 'tools';

export const WORKSPACE_NAV: AppNavItem[] = [
  { key: WORKSPACE_HOME_KEY, label: 'Home', icon: <House />, href: '/tools', section: 'Workspace' },
  { key: 'documents', label: 'Documents', icon: <FileText />, href: '/documents', section: 'Workspace' },
  { key: 'links', label: 'Links', icon: <Link2 />, href: '/links', section: 'Workspace' },
  { key: 'jobs', label: 'Jobs', icon: <Activity />, href: '/jobs', section: 'Workspace' },
  { key: 'settings', label: 'Settings', icon: <Settings />, href: '/settings', section: 'Account' },
];

// Tab title of each app-host page the rail does not list (W.4.132). A path
// that only redirects has no entry: the page it lands on sets the title.
// `/tools/:slug` names its tool in ToolsAppDetailPage.
const APP_PAGE_LABELS: ReadonlyArray<readonly [RegExp, string]> = [
  [/^\/links\/new$/, 'Create link'],
  [/^\/links\/[^/]+\/settings$/, 'Link settings'],
  [/^\/spaces$/, 'Spaces'],
  [/^\/spaces\/[^/]+$/, 'Space'],
  [/^\/inboxes(\/[^/]+)?$/, 'Inbox'],
  [/^\/agents$/, 'Agents'],
  [/^\/agents\/redact$/, 'Redact agent'],
  [/^\/claim\/[^/]+$/, 'Claim inbox'],
  [/^\/live-docs\/[^/]+\/claim$/, 'Claim document'],
  [/^\/studio$/, 'Studio'],
  [/^\/sign-in(\/.*)?$/, 'Sign in'],
  [/^\/sign-up(\/.*)?$/, 'Sign up'],
];

export function appPageLabel(pathname: string): string | null {
  const path = pathname.replace(/\/+$/, '');
  const navItem = WORKSPACE_NAV.find((item) => item.href === path);
  if (navItem) return navItem.label;
  return APP_PAGE_LABELS.find(([pattern]) => pattern.test(path))?.[1] ?? null;
}
